<div class="page-container" [class.loading]="isLoading">
    <!--Header-->
    <div class="heading">
        <app-header
            title="{{ 'employees.organizationChart.people' | translate }}"
            [menuService]="employeeModuleMenuService"
        >
            <div class="buttons">
                <!--Org Chart Button-->
                <div class="ui toggle buttons">
                    <div class="ui icon basic button" (click)="goToChartView()">
                        <mat-icon svgIcon="orgChart"></mat-icon>
                    </div>
                    <div class="ui icon basic disabled button"><mat-icon svgIcon="list"></mat-icon></div>
                </div>

                <!--Filters-->
                <app-deprecated-filter
                    [filters]="filters"
                    [filterValues]="filterValues"
                    (filter)="onFilter($event)"
                ></app-deprecated-filter>

                <ui-button class="context-menu" [matMenu]="settingsMatMenu">
                    <mat-icon svgIcon="settings"></mat-icon>
                </ui-button>

                <ui-button class="context-menu" [matMenu]="contextMatMenu">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </ui-button>

                <ui-button type="primary" (click)="print()">{{
                    'employees.organizationChart.download' | translate
                }}</ui-button>
            </div>
        </app-header>
    </div>

    <!--Accordion-->
    <div class="ui segment transparent">
        <div class="ui styled fluid accordion">
            <ng-container *ngFor="let employee of employees">
                <app-org-accordion-item
                    [employee]="employee"
                    [showPhoto]="togglePhotos"
                    [showName]="toggleNames"
                    [showPosition]="togglePositions"
                    [showDepartment]="toggleDepartments"
                >
                </app-org-accordion-item>
            </ng-container>
        </div>
    </div>

    <mat-menu #settingsMatMenu>
        <div class="padding-x-2 margin-top-1 margin-bottom-2">
            <a (click)="toggleNames = !toggleNames">
                <mat-icon class="margin-right-1" *ngIf="toggleNames" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!toggleNames" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.employeeNames' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="togglePhotos = !togglePhotos">
                <mat-icon class="margin-right-1" *ngIf="togglePhotos" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!togglePhotos" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.employeePhotos' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-2">
            <a (click)="toggleDepartments = !toggleDepartments">
                <mat-icon class="margin-right-1" *ngIf="toggleDepartments" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!toggleDepartments" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.department' | translate }}</span>
            </a>
        </div>
        <div class="padding-x-2 margin-bottom-1">
            <a (click)="togglePositions = !togglePositions">
                <mat-icon class="margin-right-1" *ngIf="togglePositions" svgIcon="check"></mat-icon>
                <mat-icon class="margin-right-1" *ngIf="!togglePositions" svgIcon="subtract"></mat-icon>
                <span>{{ 'employees.organizationChart.positions' | translate }}</span>
            </a>
        </div>
    </mat-menu>
    <mat-menu #contextMatMenu>
        <div class="padding-x-2 margin-top-1 margin-bottom-2">
            <a (click)="expandAll()">
                <mat-icon class="margin-right-1" svgIcon="expand"></mat-icon
                >{{ 'employees.organizationChart.expandAll' | translate }}</a
            >
        </div>
        <div class="padding-x-2 margin-bottom-1">
            <a (click)="collapseAll()">
                <mat-icon class="margin-right-1" svgIcon="collapse"></mat-icon
                >{{ 'employees.organizationChart.collapseAll' | translate }}</a
            >
        </div>
    </mat-menu>
</div>
